module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', {
    directives: [{
      name: "min-height",
      rawName: "v-min-height"
    }]
  }, [_c('c-page', [_c('c-content', [_c('div', {
    staticClass: "alpha-register"
  }, [_c('div', {
    staticClass: "header bg-img",
    class: [_vm.isMiniProgramModel ? 'bg-img--miniprogram' : '']
  }, [_c('div', {
    staticClass: "header-desc"
  }, [_c('img', {
    staticClass: "alpha-logo",
    attrs: {
      "src": require("../../assets/images/logo/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-desc"
  }, [_vm._v("欢迎注册生意专家")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "register-form"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "s-form-group"
  }, [_c('i', {
    staticClass: "s-icon s-icon-store prepend-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.formData.storename),
      expression: "formData.storename",
      modifiers: {
        "trim": true
      }
    }],
    ref: "J_shopName",
    staticClass: "prepend-icon",
    attrs: {
      "type": "text",
      "placeholder": "店铺名称（8个字以内）"
    },
    domProps: {
      "value": (_vm.formData.storename)
    },
    on: {
      "blur": [_vm.resetScroll, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.storename = $event.target.value.trim()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-form-group"
  }, [_c('i', {
    staticClass: "s-icon s-icon-telephone prepend-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.formData.account),
      expression: "formData.account",
      modifiers: {
        "trim": true
      }
    }],
    ref: "J_phone",
    staticClass: "prepend-icon",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "phone",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.formData.account)
    },
    on: {
      "blur": [_vm.handlerBlurPhone, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.account = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "code-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getSmsCap
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.content) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "s-form-group"
  }, [_c('i', {
    staticClass: "s-icon s-icon-password prepend-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.formData.vercode),
      expression: "formData.vercode",
      modifiers: {
        "trim": true
      }
    }],
    ref: "smsCode",
    staticClass: "prepend-icon",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "max": "6",
      "placeholder": "请输入短信验证码"
    },
    domProps: {
      "value": (_vm.formData.vercode)
    },
    on: {
      "blur": [_vm.resetScroll, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.vercode = $event.target.value.trim()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-form-group"
  }, [_c('i', {
    staticClass: "s-icon s-icon-password prepend-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.formData.password),
      expression: "formData.password",
      modifiers: {
        "trim": true
      }
    }],
    ref: "J_pwd",
    staticClass: "prepend-icon",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "blur": [_vm.resetScroll, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value.trim()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "s-btn s-btn--orange",
    class: [_vm.isMiniProgramModel ? 's-btn--miniprogram' : ''],
    on: {
      "click": function($event) {
        _vm.nextStep()
      }
    }
  }, [_vm._v("\n            下一步\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-20 text-center text-color gray"
  }, [_vm._v("\n            点击下一步，即同意\n            "), _c('a', {
    staticClass: "text-color link",
    class: [_vm.isMiniProgramModel ? 'link--miniprogram' : ''],
    on: {
      "click": function($event) {
        _vm.goUserTerm()
      }
    }
  }, [_vm._v("《生意专家用户协议》")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-container"
  }, [_c('info-footer')], 1)])]), _vm._v(" "), (_vm.showDialog) ? _c('c-dialog', [_c('div', {
    slot: "bd-content"
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.inputImgCode),
      expression: "inputImgCode",
      modifiers: {
        "trim": true
      }
    }],
    ref: "J_code",
    staticClass: "prepend-icon",
    staticStyle: {
      "width": "60%",
      "margin-right": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入图形验证码"
    },
    domProps: {
      "value": (_vm.inputImgCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputImgCode = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.codeImg,
      "alt": ""
    },
    on: {
      "click": _vm.initCodePath
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    on: {
      "click": function () { return (this$1.showDialog = false); }
    }
  }, [_c('div', {
    attrs: {
      "type": "button"
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendSms
    }
  }, [_vm._v("确定")])])])]) : _vm._e()], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7a8fd24","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/agent-register-user/index.vue
// module id = 390
// module chunks = 0